import { ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { DownloadIssuedLetterService } from './services/download-issued-letter.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { updateLetterComponent } from '../update-letter/update-letter.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { decrypt } from '../../../../utilities/utilityFunctions';
import { SharedService } from '../../../../shared/sharedServices/shared.service';

@Component({
  selector: 'kt-download-issued-letters',
  templateUrl: './download-issued-letters.component.html',
  styleUrls: ['./download-issued-letters.component.css']
})
export class DownloadIssuedLettersComponent implements OnInit {
  public degreeList:any;
  public selectedDegree:any = {};
  public appId:number;
  public imageContent:any;
  public imageType:string = 'pdf';
  public letterText:any;
  public subjectText:any;
  @ViewChild('letterissueForm',{static:false}) letterissueForm: NgForm;
  isAdminVerfication: boolean = false;
  private _onDestroy = new Subject<void>();
  showUpdate: boolean =false;
  isAdminRole: boolean = false;
  constructor(private dialogRef: MatDialogRef<DownloadIssuedLettersComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private matDialog: MatDialog,
  private loaderService:LoaderService, private downloadIssued:DownloadIssuedLetterService,
  private sharedServices:SharedService,
  private cdr:ChangeDetectorRef,private dom:DomSanitizer, private router:Router) { }

  ngOnInit() {
    this.degreeList = this.data.degrees
    this.isAdminVerfication = this.data.isAdminVerfication
    this.appId = this.data.appId;
    console.log(this.degreeList)

    if (localStorage.getItem('esp-profile-details')) {
			const profileDetails = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')));
		  	this.isAdminRole = this.sharedServices.checkLetterUpdateAdminCategory(profileDetails.getSpRole)
		   }
  }

  public getSelectedLetter(value){

  if(this.isAdminRole && this.data.acronym.toLowerCase() =='des')  
  {
    this.showUpdate = true
    this.cdr.detectChanges();
  
  }
 

    if(this.data.acronym.toLowerCase() =='des'){

    this.selectedDegree.letterName = this.degreeList.find(d=>d.value == value).letterName
    this.selectedDegree.university = this.degreeList.find(d=>d.value == value).university
    this.selectedDegree.degreeTitle = this.degreeList.find(d=>d.value == value).degreeTitle
    this.selectedDegree.desDegreeId = this.degreeList.find(d=>d.value == value).desDegreeId
    this.selectedDegree.letterId = this.degreeList.find(d=>d.value == value).letterId

    
  

    this.loaderService.setValue(true);
    let paylaod = {
      data:{
        desDegreeId:this.selectedDegree.desDegreeId,
        letterId:this.selectedDegree.letterId,
        degreeTitle:this.selectedDegree.degreeTitle,
        university:this.selectedDegree.university
      }}

    this.downloadIssued.generateLetter(this.appId,paylaod,this.data.acronym.toLowerCase()).subscribe(
      (res)=>{
        if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.loaderService.setValue(false);
          this.imageContent = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+res.data);
          this.cdr.detectChanges();
        }else{
          this.loaderService.setValue(false);
          this.cdr.detectChanges();

        }
      }
    )
  }else if(this.data.acronym.toLowerCase() =='desf'){
    // this.selectedDegree.letterName = this.degreeList.find(d=>d.value == value).letterName
    // this.selectedDegree.university = this.degreeList.find(d=>d.value == value).university
    // this.selectedDegree.degreeTitle = this.degreeList.find(d=>d.value == value).degreeTitle
    this.selectedDegree.desDegreeId = this.degreeList.find(d=>d.value == value).desDegreeId
	// this.selectedDegree.letterId = this.degreeList.find(d=>d.value == value).letterId

	this.selectedDegree.isFinal = this.degreeList.find(d=>d.value == value).isFinal
	let isFinal = this.selectedDegree.isFinal
  console.log(isFinal)
    this.loaderService.setValue(true);
    if(this.router.url == '/desf-tracking/tracking' || this.isAdminVerfication){
      let paylaod = {
        data:{
          desDegreeId:this.selectedDegree.desDegreeId
        }}
      this.downloadIssued.generateBody(paylaod,this.data.appId).subscribe(
      (res)=>{
        if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
        //   this.letterText = value == 0 ? res.data.PROV_BODY : res.data.FINAL_BODY,
        //   this.subjectText = value == 0 ? res.data.PROV_SUBJECT : res.data.FINAL_SUBJECT
		      this.letterText = isFinal ? res.data.FINAL_BODY : res.data.PROV_BODY,
          this.subjectText = isFinal ? res.data.FINAL_SUBJECT : res.data.PROV_SUBJECT

        let letterpaylaod = {
        data:{
          desDegreeId:this.selectedDegree.desDegreeId,
		      body: isFinal  == 1 ? res.data.FINAL_BODY :  isFinal == 0 ? res.data.PROV_BODY : res.data.TL_BODY,
		      subject: isFinal  == 1 ? res.data.FINAL_SUBJECT : isFinal == 0 ? res.data.PROV_SUBJECT : res.data.TL_SUBJECT,
		      //isFinal: isFinal ? true : null
          isFinal: isFinal 
        }}
		console.log(this.letterText, this.subjectText)
		console.log(letterpaylaod)
      this.downloadIssued.generateAdminLetter(this.appId,letterpaylaod,this.data.acronym.toLowerCase()).subscribe(
        (res)=>{
          if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
            this.loaderService.setValue(false);
            this.imageContent = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+res.data);
            this.cdr.detectChanges();
          }else{
            this.loaderService.setValue(false);
            this.cdr.detectChanges();

          }
        }
      )
          this.imageContent = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+res.data);
          this.cdr.detectChanges();
        }else{

          this.cdr.detectChanges();
        }
      },
      (err)=>{

            this.cdr.detectChanges();
          }
    )
    }
    else{

	this.selectedDegree.isFinal = this.degreeList.find(d=>d.value == value).isFinal
	console.log(this.degreeList)
	console.log(this.selectedDegree)
	let isFinal = this.selectedDegree.isFinal
    this.downloadIssued.generateApplicantLetter(this.selectedDegree.desDegreeId,this.data.acronym.toLowerCase(),isFinal).subscribe(
      (res)=>{
        if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.loaderService.setValue(false);
          this.imageContent = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+res.data);
          this.cdr.detectChanges();
        }else{
          this.loaderService.setValue(false);
          this.cdr.detectChanges();

        }
      }
    )
  }
  }
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  public updateLetter()
  {
    console.log("update")
    const dialogRef = this.matDialog.open(updateLetterComponent, {
			width: '45vw',
			backdropClass: 'instruction-popups',
      		panelClass: 'instruction-popup',
			disableClose: true,
			autoFocus: false,
			data: { model: this.selectedDegree ,appId:this.appId,isEditable:false }
		});
		dialogRef.afterClosed()
			.pipe(takeUntil(this._onDestroy))
			.subscribe(result => {
        this.dialogRef.close(false);
			});
  }

}
